<template>
    <div>
        <b-form-group label="Teléfono Cliente" label-for="client_contact_person">
            <b-form-input v-model="clientPhone" placeholder="Teléfono Cliente" :disabled="disabled"
                          :class="validation ? 'is-invalid': ''"/>
            <small v-if="validation" className="text-danger">
                {{ validation }}</small>
        </b-form-group>
    </div>
</template>

<script>
import {BFormGroup, BFormInput} from 'bootstrap-vue'

export default {
    components: {
        BFormGroup,
        BFormInput,
    },
    props: {
        clientPhone: {
            type: String,
            default: ''
        },
        validation: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localClientPhone: this.clientPhone,
        }
    },
    watch: {
        clientPhone(newVal) {
            this.localClientPhone = newVal
            this.$emit('update', { client_phone: this.localClientPhone })
        },
    },
}
</script>
